import React, { FC, useMemo } from 'react';
import styles from './userlist.module.scss';
import { IStaffDto, IStaffStudyDto } from '../../../services/api/api-client';
import { formatRelative } from 'date-fns';
import { getCurrentDateLocale } from '../../../application/localisation/localization';
import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { expandRowButtonColumn } from 'uikit/table/columns/ExpandRowButtonColumn';

export const useUserColumns = (): ColumnDef<IStaffDto>[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        accessorKey: 'fullName',
        header: 'Full Name',
        enableSorting: false,
        size: 200,
        meta: {
          top: true,
        },
      },
      {
        id: 'studies',
        header: 'Studies',
        cell: ({ row }) => <StudyList studies={row.original.studies} />,
        meta: {
          isColored: true,
          dontUseHeaderWidth: true,
          top: true,
        },
      },
      {
        id: 'lastVisitDateTime',
        accessorFn: (staff) => staff.lastVisitDate,
        header: 'Last visit date',
        cell: ({ row }) => (
          <p>
            {row.original.lastVisitDate
              ? formatRelative(row.original.lastVisitDate, Date.now(), getCurrentDateLocale())
              : t('Common_Never')}
          </p>
        ),
        size: 300,
        meta: {
          top: true,
        },
      },
      expandRowButtonColumn({}),
    ],
    [t],
  );
};

type StudyItemType = { studies: Pick<IStaffStudyDto, 'id' | 'studyNumber' | 'studyTitle'>[] };
const StudyList: FC<StudyItemType> = ({ studies }) => {
  return (
    <ul className={styles.studyList}>
      {studies.map((x, i) => (
        <li key={i}>
          <span>{x.studyNumber}</span>
          <span className={styles.title}>{x.studyTitle}</span>
        </li>
      ))}
    </ul>
  );
};
